<template>
  <el-form>
    <div class="el-table el-table--fit el-table--border" style="width:100%">
      <div v-if="formShow" class="el-table__body-wrapper">
        <table cellspacing="0" cellpadding="0" border="0" style="" class="table__body subtable el-table__body">
          <tbody>
            <tr>
              <td class="el-table__cell tdlbl right tdw17" style="position: relative;">
                <span class="required">*</span> <span v-text-lbl="'topic'">题目</span>
              </td>
              <td class="el-table__cell tdcont tdw83" colspan="5">
                <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="投票题目" rules="required">
                  <el-tooltip :disabled="errors[0]===undefined" :content="errors[0]" :class="{'invalid-field':errors[0]!==undefined}" popper-class="error-popper-class" placement="right-start" effect="dark">
                    <el-input v-model="subjectData.subject" v-can-edit name="subject" :placeholder="$tx('hygl.voteManage.votoTopicPlaceholder','投票题目')" />
                  </el-tooltip>
                </ValidationProvider>
              </td>
            </tr>
            <tr>
              <td class="el-table__cell tdlbl right tdw17" style="position: relative;">
                <span class="required">*</span> <span v-text-lbl="'topic'">题目</span>
              </td>
              <td class="el-table__cell tdcont tdw83" colspan="5">
                <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="投票类型" rules="required">
                  <el-tooltip :disabled="errors[0]===undefined" :content="errors[0]" :class="{'invalid-field':errors[0]!==undefined}" popper-class="error-popper-class" placement="right-start" effect="dark">
                    <el-radio-group v-model="subjectData.voteType" name="voteType" :placeholder="$tx('hygl.voteManage.votoTypePlaceholder','投票类型')">
                      <el-radio v-for="(option,optKey) in flType" :key="optKey" :disabled="canEdit===0" :label="option.value">{{ option.text }}</el-radio>
                    </el-radio-group>
                  </el-tooltip>
                </ValidationProvider>
              </td>
            </tr>
            <tr>
              <td class="el-table__cell tdlbl right tdw17" style="position: relative;">
                <span class="required">*</span> <span v-text-lbl="'votingOptions'">投票选项</span>
              </td>
              <td class="el-table__cell tdcont notop tdw83" colspan="5">
                <template v-if="subjectData.passenger.choices">
                  <table v-for="(_item,_index) in subjectData.passenger.choices" :key="_index" cellspacing="0" cellpadding="0" border="0" style="" class="table__body subtable el-table__body vote_option_table">
                    <!-- <tbody> -->
                    <tr>
                      <td class="el-table__cell tdlbl right tdw17"> <span v-text-lbl="'item'" :num="_index + 1">选项{{ _index + 1 }}</span> <i style="cursor: pointer;" class="el-icon-close" @click="itemdel(_index,_item)" /> </td>
                      <td class="el-table__cell tdcont nopadding tdw83">
                        <div class="flex border-b">
                          <div class="title">
                            <span class="required">*</span>
                            {{ $tx('hygl.voteManage.optionTitle','选项标题') }}
                          </div>
                          <div class="content">
                            <ValidationProvider v-if="canEdit===1" ref="ValidationProvider" v-slot="{ errors }" :name="`选项${+_index + 1}`" rules="required">
                              <el-tooltip :disabled="errors[0]===undefined" :content="errors[0]" :class="{'invalid-field':errors[0]!==undefined}" popper-class="error-popper-class" placement="right-start" effect="dark">
                                <el-input v-model="_item.subject" name="subject2" :placeholder="$tx('hygl.voteManage.item',{num:_index + 1},`选项${_index + 1}`)" />
                              </el-tooltip>
                            </ValidationProvider>
                            <span v-else v-html="_item.subject" />
                          </div>
                        </div>
                        <div class="flex ">
                          <div class="title"> <span> <span v-text-lbl="'pic'"></span> 图片 </span> </div>
                          <div class="content">
                            <el-upload
                              v-if="canEdit===1"
                              ref="upload"
                              :on-change="handleUploadChange"
                              action=""
                              :multiple="true"
                              :file-list="fileList[_item.id]"
                              :show-file-list="false"
                              :auto-upload="false"
                              :with-credentials="true"
                              accept=".jpg,.png"
                            >
                              <el-input v-model="_item.coverUrl" name="coverUrl" :placeholder="$tx('hygl.voteManage.picPlaceholder','请选择图片')" @focus="handleUploadClick(_item)">
                                <el-button slot="append" icon="el-icon-upload2" @click="handleUploadClick(_item)" />
                              </el-input>
                            </el-upload>
                            <div v-show="_item.imgData">
                              <img class="img-box img-box1" :src="_item.imgData" style="height: 100px;">
                            </div>
                            <div v-show="!_item.imgData">
                              <el-divider v-if="!_item.isnew && canEdit === 1 && _item.coverUrl" />
                              <span v-if="!_item.isnew && _item.coverUrl" v-html="_item.attachHtml" />
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </table>
                </template>
              </td>
            </tr>
          </tbody>
        </table>
        <div v-if="canEdit===1" class="item-btn-box">
          <div v-if="canEdit===1" class="btn-box">
            <span style="cursor: pointer;" @click="itemAdd()">
              <i class="el-icon-plus" /><span v-text-lbl="'addItem'" style="margin-left:10px"> 添加选项 </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </el-form>
</template>

<script>
export default {
    components: {

    },
    props: {
        moduleInfo: { type: Object, default: function() { return {} } },
        canEdit: { type: Number, default: 1 },
        subjectData: { type: Object, default: function() { return {} } }
    },
    data() {
        return {
            i18npkg: 'hygl',
            moduleCode: 'voteManage',
            flType: [
                { value: 1, text: this.$tx('hygl.voteManage.Radio', '单选') },
                { value: 2, text: this.$tx('hygl.voteManage.multipleChoice', '多选') }
            ],
            urlInfo: {
                addSubjectUrl: 'hygl/voteSubject/addNew',
                addVoteChoices: 'hygl/voteChoices/addNew',
                delVoteChoices: 'hygl/voteChoices/delete'
            },
            passengerObj: {
                id: '',
                orderNo: null,
                passenger: {
                    passenger: [
                        {
                            id: '',
                            orderNo: '',
                            passenger: {},
                            status: 1,
                            subject: '',
                            subjectId: ''
                        },
                        {
                            id: '',
                            orderNo: '',
                            passenger: {},
                            status: 1,
                            subject: '',
                            subjectId: ''
                        }
                    ]
                },
                status: 1,
                subject: '',
                voteId: '',
                voteType: 1
            },
            formShow: true,
            fileList: {},
            activeItem: {},
            imgDataList: []
        }
    },
    computed: {
    },
    watch: {

    },
    created() {
        console.log('this.subjectData', this.subjectData)
        this.subjectData.passenger.choices.forEach(item => {
            if (!item.isnew) {
                const downloadUrl = process.env.VUE_APP_BASE_API + '/hygl/vote/download?id=' + item.id + '&nameFiled=coverUrl&dataFiled=coverFile&httpPort=' + location.port
                item.attachHtml = "<img class='img-rview' style='max-width:100px;max-height:100px;' src='" + downloadUrl + "' object-fit='scale-down'/>"
            }
        })
    },
    beforeDestroy() {

    },
    mounted() {
    },
    methods: {
        // 新增选项
        itemAdd() {
            this.$http({
                method: 'POST',
                contentType: 'application/x-www-form-urlencoded',
                url: this.urlInfo.addVoteChoices
            }).then(res => {
                if (res.code === 'success') {
                    const choiceObj = res.body.vo
                    choiceObj.status = 1
                    choiceObj.subjectId = this.subjectData.id
                    choiceObj.isnew = true

                    this.subjectData.passenger.choices.push(choiceObj)

                    this.$forceUpdate()
                } else {
                    this.$alert(res.message, this.$tx('common.operationTip', '操作提示'), { type: 'error' })
                }
            })
        },
        itemdel(index, item) {
            if (this.canEdit === 1) {
                this.subjectData.passenger.choices.splice(index, 1)
                delete this.fileList[item.id]
                delete this.$vnode.context.fileList[item.id]
                this.$forceUpdate()
            }
        },
        handleUploadClick(item) {
            this.activeItem = item
        },
        handleUploadChange(file) {
            this.fileList[this.activeItem.id] = [file]
            this.$vnode.context.fileList[this.activeItem.id] = [file]
            const reader = new FileReader()
            const _this = this
            const activeId = this.activeItem.id
            reader.addEventListener('load', function(e) {
                _this.$vnode.context.imgUrl.push({
                    id: activeId,
                    url: reader.result
                })
                _this.activeItem.imgData = e.target.result
                // _this.subjectData.passenger.choices.forEach(item => {
                //     if (item.id === _this.activeItem.id) {
                //         item.imgData = reader.result
                //     }
                // })
                console.log('this.subjectData111==', _this.subjectData)
            })
            reader.readAsDataURL(file.raw)
            // _this.imgDataList = _this.$vnode.context.imgUrl
            // console.log('_this.imgDataList', _this.imgDataList)
            // _this.imgDataList.forEach(img => {
            //     console.log('111', img)
            //     if (img.id === this.activeItem.id) {
            //         console.log(555)
            //         this.activeItem.imgData = img.url
            //     }
            // })
            // console.log('this.activeItem', this.activeItem)
            // this.activeItem.imgData = file.raw
            this.subjectData.passenger.choices.forEach(item => {
                if (item.id === this.activeItem.id) {
                    item.coverUrl = file.name
                    item.imgData = reader.result
                }
            })
            console.log('this.subjectData222==', this.subjectData)
            this.$forceUpdate()
        }
    }
}
</script>

<style scoped lang="scss">
.flex{
  display: flex;
}
.right{
  text-align: right;
  padding-right: 8px;
}
.notop{
  padding: 0px !important;
  border-right: none;
}
.el-table td{
  padding: 4px;
}
.btn-box {
  display: flex;
  justify-content: center;
  padding: 5px;
  height: 72px;
  align-items: center;
}
.delicon {
  width: 15px;
  height: 15px;
  position: absolute;
  top: 10px;
  left: 10px;
  display: none;
  cursor: pointer;
  img {
    width: 100%;
    height: 100%;
    vertical-align: top;
  }
}
.subtable {
  width:100%
}
.subtable:hover {
  .delicon {
    display: block;
  }
}
.item-btn-box {
  margin-top: 10px;
  img {
    width: 10px;
    height: 10px;
  }
}
// .el-table__body{
//   &.el-table__body-no{
//     table-layout:auto
//   }
// }
.title{
  width: 133px;
  padding: 4px;
  border-right: 1px solid #EBEEF5;
  text-align: right;
}
.content{
  flex: 1;
  padding:0 4px;
  line-height: 47px;
  /deep/ .el-upload{
    width: 100%;
  }
  /deep/ .el-divider--horizontal{
    margin:10px 0
  }

}
.nopadding{
  padding: 0px !important;
  border-right:0;
}
.border-b{
  border-bottom:  1px solid #EBEEF5;
  .required{
    color: #ff0000;
    margin-right: 3px;
  }
}
.vote_option_table:last-child{
  tr td{
    border-bottom:0;
  }
}
</style>
